import * as React from 'react';
import { connect } from "react-redux";
import UserSettings from '../settings/model/Settings';
import MessageItem from './MessageItem';
import MessageListHeader from './MessageListHeader';
import Message from "./model/Message";

interface IMessageListProps {
  messageList: Message[];
  settings: UserSettings;
}
export class MessageList extends React.Component<IMessageListProps> {
  constructor(props: IMessageListProps) {
    super(props);
  }

  public render() {
    const messageItems = this.props.messageList && this.props.messageList.length > 0 ? this.props.messageList.map((message) =>
      <MessageItem key={message.id} message={message} />
    ) : (<tr className="desktop email-item row"><td className="col-sm-12">No messages</td></tr>);

    return (
      <div className="table-responsive desktop">
        <table className="table table-fixed">
          <MessageListHeader/>
          <tbody>
            {messageItems}
          </tbody>
        </table>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    messageList: state.mail.messageList,
    settings: state.settings.settings
  };
}

export default connect(mapStateToProps, null)(MessageList);




// WEBPACK FOOTER //
// ./src/components/mail/MessageList.tsx